import { FC } from 'react'

interface IProps {
  icon: JSX.Element
  title: string
  description: string
}

const IconCard: FC<IProps> = ({ icon, title, description }) => {
  return (
    <article className="flex h-full flex-col rounded-xl bg-white px-6 py-9">
      <span className="mb-6 flex w-fit items-center justify-center rounded-xl bg-primary-light p-6 text-primary">
        {icon}
      </span>
      <h4 className=" mb-2">{title}</h4>
      <p className="leading-[22px]">{description}</p>
    </article>
  )
}

export default IconCard
